'use client';

import { usePathname } from '@/i18n/routing';

export function useIsAiVideoEditorRoute() {
  const pathname = usePathname();

  return pathname.includes('/create/ai-video-cutter');
}
